import React, { useEffect, useState } from 'react';
import { IProduct, IRating } from '../../interfaces/product';
import { useParams } from 'react-router-dom';
import { callApi } from '../../api/callApi';
import { API_ENDPOINT, API_URL_2 } from '../../api/constant';
import Layout from '../../components/Layout/Layout';
import { Link } from 'react-router-dom';
import moment from '../../utility/moment-timezone';
const ProductDetailsPage: React.FC = () => {
    const [product, setProduct] = useState<IProduct | null>(null);
    const [ratings, setRatings] = useState<IRating[]>([]);
    const [loading, setLoading] = useState(true);
    const { id } = useParams()
    useEffect(() => {
        async function fetchData() {
            try {
                const response = await callApi(
                    API_URL_2 + API_ENDPOINT.page + `products/${id}`,
                    { method: "GET" }
                );
                setProduct(response);

                const raringResponse = await callApi(
                    API_URL_2 + API_ENDPOINT.page + `products/rating/${id}`,
                    { method: "GET" }
                );
                setRatings(raringResponse.data);
            } catch (err: any) {
                console.log("Error:", err?.message)
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, []);

    if (loading) {
        return <Layout ><p>Loading...</p></Layout>;
    }

    if (!product) {
        return <Layout ><p>No product found.</p></Layout>;
    }

    // Calculate average rating (if ratings exist)
    const averageRating =
        ratings.length > 0
            ? ratings.reduce((sum, r) => sum + r.rating, 0) / ratings.length
            : 0;



    return (
        <Layout>
            <div className="container my-4">


                {/* Product Details Section */}
                <div className="card my-4">
                    <div className="card-header">Product Details</div>
                    <div className="card-body">
                        <div className="row">
                            {/* Product Image Gallery */}
                            <div className="col-md-4">
                                {product.images && product.images.length > 0 ? (
                                    <img
                                        src={product.images[0]}
                                        alt={product.title}
                                        className="img-fluid"
                                        style={{ borderRadius: '5px' }}
                                    />
                                ) : (
                                    <div>No image available</div>
                                )}
                                {/* You can add a thumbnail gallery here if needed */}
                            </div>
                            {/* Product Info */}
                            <div className="col-md-8">
                                <h3 className="d-flex align-items-center mb-0">
                                    <span className="me-2">{product.title}</span>

                                    <Link
                                        to={`/edit-product/${product.id}`}
                                        className="btn btn-outline-secondary btn-icon"
                                        title="Edit"
                                        role="button"
                                    >
                                        <i className="bi bi-pencil-fill" aria-hidden="true" />
                                    </Link>
                                </h3>


                                <p><strong>Category:</strong> {product.typeOfMeat[0]}</p>
                                <p><strong>Cut:</strong> {product.cut}</p>
                                <p><strong>Brand:</strong> {product.brand}</p>
                                <p><strong>State:</strong> {product.state}</p>
                                <p>
                                    <strong>Average Rating:</strong>{' '}
                                    <span
                                        className="star-rating"
                                        style={{ color: '#ffc107', fontSize: '1.2rem' }}
                                    >
                                        {'★'.repeat(Math.round(averageRating)) + '☆'.repeat(5 - Math.round(averageRating))}
                                    </span>{' '}
                                    ({ratings.length > 0 ? averageRating.toFixed(1) : 'No ratings'})
                                </p>
                                <p><strong>Description:</strong> {product.description}</p>
                                <p><strong>Additional Info:</strong> {product.additionalInfo}</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Product Variants Section */}
                <div className="card my-4">
                    <div className="card-header">Product Variants</div>
                    <div className="card-body">
                        {product.productInfo && product.productInfo.length > 0 ? (
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Variant ID</th>
                                        <th>Price</th>
                                        <th>Quantity</th>
                                        <th>Discount %</th>
                                        <th>Discounted Price</th>
                                        <th>Piece Weight</th>
                                        <th>VAT Included</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {product.productInfo.map((info) => (
                                        <tr key={info.id}>
                                            <td>{info.id}</td>
                                            <td>{info.price}</td>
                                            <td>{info.quantity}</td>
                                            <td>{info.discountPercentage ? `${info.discountPercentage}%` : 'N/A'}</td>
                                            <td>{info.discountedPrice ? info.discountedPrice : info.price}</td>
                                            <td>{info.pieceWeight}</td>
                                            <td>{info.isVatIncluded ? 'Yes' : 'No'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <p>No variants available.</p>
                        )}
                    </div>
                </div>

                {/* Customer Reviews Section */}
                <div className="card my-4">
                    <div className="card-header">Customer Reviews</div>
                    <div className="card-body">
                        {ratings.length > 0 ? (
                            ratings.map((rating) => (
                                <div key={rating.id} className="mb-4">
                                    <h5>
                                        {rating.userName}{' '}
                                        <Link to={`/order-details/${rating.orderId}`} className="text-decoration-none">
                                            (View Order)
                                        </Link>{' '}
                                        <small className="text-muted">
                                            - {moment(rating.createdAt).format('DD MMM, YYYY')}
                                        </small>
                                    </h5>
                                    <p
                                        className="star-rating"
                                        style={{ color: '#ffc107', fontSize: '1.2rem' }}
                                    >
                                        {'★'.repeat(Math.round(rating.rating)) +
                                            '☆'.repeat(5 - Math.round(rating.rating))}
                                    </p>
                                    <p>{rating.review}</p>
                                    {/* Display rating images if available */}
                                    {rating.imageUrl && rating.imageUrl.length > 0 && (
                                        <div className="d-flex flex-wrap">
                                            {rating.imageUrl.map((url, index) => (
                                                <img
                                                    key={index}
                                                    src={url}
                                                    alt={`Review image ${index + 1}`}
                                                    className="img-thumbnail me-2 mb-2"
                                                    style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                                                />
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))
                        ) : (
                            <p>No reviews yet.</p>
                        )}
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default ProductDetailsPage;
